import React, { useState, useEffect, useRef } from "react";
import Navigation from "./navigation";
import NavInfoAccount from "./navInfoAccount";
import AccountInput from "./accountInput";
import SaveChanges from "./saveChanges";
import useScrollToTop from "./useScrollToTop";
import AccountInstructor from "./accountInstructor";
import EmailAddress from "./emailAddress";
import Support from "./support";
import { useNavigate } from "react-router-dom";
import useWindowWidth from "./useWindowWidth";
import DockerfileBlock from "./dockerfileBlock";
import SelectZipFile from "./selectZipFile";
import validateDockerfile from "./validateDockerfile";
import uploadFile from "./uploadFileToS3";
import Loading from "./loading";
import DeleteDockerAccount from "./deleteDockerAccount";

const AccountSettings = () => {
    const navigate = useNavigate();
    useScrollToTop();
    const [text, setText] = useState("Save Changes");
    const [account, setAccount] = useState({
        name: "",
        primaryEmail: "",
        dockerArray: []

    });
    const width = useWindowWidth(850);
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const [requestLifeCycleAccount, setRequestLifeCycleAccount] = useState(false);
    const [deleteDocker, setDeleteDocker] = useState({
        delete: false,
        dockerfile: null
    });
    const dockerfileRef = useRef(null);
    const [dockerfiles, setDockerfiles] = useState({

    })

    function updateDockerfiles(newDockerUuid, newDockerfile) {
        setDockerfiles((prev) => {
            return {
                ...prev,
                [newDockerUuid]: newDockerfile
            }
        })
    }

    function updateDeleteDocker(bool, dockerfile) {
        setDeleteDocker({
            delete: bool,
            dockerfile: dockerfile
        });
    }

    function updateDockerArray(dockerUuid, newInfo) {
        setAccount((prev) => {
            return {
                ...prev,
                dockerArray: prev?.dockerArray?.map((dockerfile) => {
                    if (dockerfile?.dockerUuid !== dockerUuid) return dockerfile;

                    return {
                        ...newInfo
                    }
                })
            }
        })
    }

    function addToDockerArray(newItem) {
        setAccount((prev) => {
            return {
                ...prev,
                dockerArray: [newItem, ...prev?.dockerArray]
            }
        })
    }

    function removeFromDockerfile(dockerUuid) {
        setAccount((prev) => ({
            ...prev,
            dockerArray: prev?.dockerArray?.filter((dockerfile) => dockerfile?.dockerUuid !== dockerUuid)
        }));
    }    

    useEffect(() => {
        const fetchCourse = async () => {
            try {
                setRequestLifeCycleAccount(true);
                const res = await fetch( process.env.REACT_APP_USER_API_URL + `/get-account-information`, {
                    method: "GET",
                    credentials: "include"
                });
                const data = await res.json();
                if (res.status === 401) {
                    window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
                }
                setAccount(data);
                updateName(data.name)
        
            } catch (error) {
                console.log(error);
            } finally {
                setRequestLifeCycleAccount(false);
            }
        }

        fetchCourse();
    }, [])

    const [form, setForm] = useState({
        name: account.name,
        studentId: "NA",
        newPassword: "",
        newPasswordConfirmation: "",
    });
    const [dockerForm, setDockerForm] = useState({
        name: "",
        dockerfile: "NA"
    })

    function updateDockerfile(value) {
        setDockerForm((prev) => {
            return {
                ...prev,
                dockerfile: value
            }
        })
    }

    function updateDockerName(value) {
        setDockerForm((prev) => {
            return {
                ...prev,
                name: value
            }
        })
    }

    function updateName(name) {
        setForm(prevForm => ({
            ...prevForm,
            name: name
        }))
    }

    function updateNewPassword(newPassword) {
        setForm(prevForm => ({
            ...prevForm,
            newPassword: newPassword
        }))
    }

    function updateNewPasswordCofirmation(newPasswordConfirmation) {
        setForm(prevForm => ({
            ...prevForm,
            newPasswordConfirmation: newPasswordConfirmation
        }))
    }

    const handleLogout = async () => {
        try {
            const res = await fetch( process.env.REACT_APP_USER_API_URL + "/logout", {
                method: "POST",
                credentials: "include"
            })
            const data = await res.json();
            
            if (res.status === 401 || res.status === 200) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL.replace(/\/login$/, '');
            } else {
                alert("Status Code: " + res.status + " Error: " + data.detail);
            }
        } catch (error) {
            alert("Error: " + error.message);
            console.log(error)
        }
    }

    const resetForm = (e) => {
        e.preventDefault();
        setForm({
            name: account.name,
            studentId: "NA",
            newPassword: "",
            newPasswordConfirmation: "",
        })
    }

    const submitForm = async (e) => {
        e.preventDefault();
        
        for (const value in form) {
            if (form[value] === "" && !value.includes("Password")) {
                setText("Blank fields")
                return;
            }
        }

        if (form.name.length > 100) {
            setText("Name too long")
            return;
        }

        if (form.newPassword.length > 64) {
            setText("Password too long")
            return;
        }

        if (form.name.trim() === "") {
            setText("Remove whitespace");
            return;
        }

        if ((form.newPassword.length < 12) && form.newPassword !== "") {
            setText("Password length");
            return;
        }

        if (((form.newPassword !== form.newPasswordConfirmation)) && form.newPassword !== "") {
            setText("Passwords differ");
            return;
        }

        const url =  process.env.REACT_APP_USER_API_URL + "/update-account-info";

        const urlOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(form)
        }

        try {
            const res = await fetch(url, urlOptions);
            const data = await res.json();

            if (res.status === 200) {
                window.location.reload();
            } else if (res.status === 415) {
                setText("Invalid characters")
            } else if (res.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else {
                alert("Status Code: " + res.status + " Error: " + data.detail);
            }
    
        } catch (error) {
            alert("Error: " + error.message);
            console.log(error);
        }        
    }

    const pageInfo = [
        {
            top : "Password (12+ Characters)",
            value : form.newPassword,
            updateValue : updateNewPassword,
            autoComplete : "new-password",
            required : false,
        },
        {
            top : "Password Confirmation",
            value : form.newPasswordConfirmation,
            updateValue : updateNewPasswordCofirmation,
            autoComplete : "new-password",
            required : false,
        },
    ]

    const handleClick = (event, path) => {
        if (event.metaKey || event.ctrlKey) {
            // Open in a new tab
            window.open(`/${path}`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${path}`);
        }
    }

    const validateDockerfileAsync = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = (event) => {
                const content = event.target.result;
                const [isValid, msg] = validateDockerfile(content);
    
                if (!isValid) {
                    reject(new Error(msg));
                } else {
                    resolve();
                }
            };
    
            reader.readAsText(file);
        });
    };

    const submitDockerForm = async () => {
        if (requestLifeCycle) {
            return;
        }

        if (dockerForm.name === "") {
            alert("Please enter a valid name")
            return
        }

        if (dockerForm.dockerfile !== "NA" && dockerForm.dockerfile?.name?.toLowerCase() !== 'dockerfile') {
            updateDockerfile("NA");
            if (dockerfileRef.current) {
                dockerfileRef.current.value = null;
            }
            
            alert("Dockerfile input's name is not \"Dockerfile\"");
            return;
        }

        try {
            await validateDockerfileAsync(dockerForm.dockerfile);
        } catch (error) {
            console.log(error);

            updateDockerfile("NA");
            if (dockerfileRef.current) {
                dockerfileRef.current.value = null;
            }

            alert("Dockerfile error: " + error.message);
            return;
        }

        const url = process.env.REACT_APP_EVALUATION_API_URL + "/upload-dockerfile";

        const urlOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name: dockerForm.name
            })
        };

        try {
            setRequestLifeCycle(true)
            const res = await fetch(url, urlOptions);
            const data = await res.json();
            if (res.status === 200) {
                if (data.url && form.dockerfile !== "NA") {
                    const imageStatus = await uploadFile(dockerForm.dockerfile, data.url, "text/plain");
                    
                    if (imageStatus !== 200) {
                        alert("Docker image failed to upload");
                        return;
                    }
                }

                addToDockerArray(data.dockerfile);

                setDockerForm({
                    name: "",
                    dockerfile: "NA"
                })

            } else if (res.status === 400 || res.status === 415 || res.status === 409) {
                alert(data.detail);
            } else {
                alert("Status Code: " + res.status + " Error: " + data.detail);
            }

        } catch (error) {
            alert("Error: " + error.message)
            console.log(error);
        } finally {
            setRequestLifeCycle(false)
        }
    }    

    return (
        <>
            <Navigation bool={false} info={ <NavInfoAccount /> }/>
            {
                requestLifeCycleAccount ?

                <div className="loading-zip-container">
                    <Loading />
                </div>

                :

                <div className="courses-container">
                    <div className={"single-course-container viewer full height"}>
                        <div className="settings-container">
                            <div className="middle-content" style={{ borderLeft: width ? "none" : "", borderRight: width ? "none" : "" }}>
                                <div className="account-settings-content">
                                    <div className="side-nav-info-header" style={{ width: "100%" }}>
                                        <div className="dockerfile-title">
                                            Docker Environments
                                            <div className="upload-docker" onClick={submitDockerForm}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                                                </svg>
                                                Upload
                                            </div>
                                        </div>
                                        {
                                            requestLifeCycle ?

                                            <div className="loading">
                                                <Loading />
                                            </div>

                                            :

                                            <>
                                                <div className="upload-new-docker">
                                                    <div className="points-viewing-container">
                                                        <div style={{ width: "45%", position:'relative' }}>
                                                            <div className="top-input">
                                                                New Environment Name
                                                                <div className="required">
                                                                    *
                                                                </div>
                                                            </div>
                                                            <input className="bottom-input" type="text" placeholder="Dockerfile Environment Name" value={dockerForm.name} onChange={(e) => {updateDockerName(e.target.value)}}/>
                                                        </div>
                                                        <div style={{ width: "45%", position: "relative" }}>
                                                            <SelectZipFile dockerDocs={true} zipFileRef={dockerfileRef} star={true} accept={""} value={dockerForm.dockerfile} updateValue={updateDockerfile} top={"New Dockerfile"} required={true}/>
                                                        </div>
                                                    </div>
                                                </div>   
                                            </>

                                        }                                 
                                        <div className="dockerfile-container-account">
                                            {
                                                account?.dockerArray?.map((dockerfile) => {
                                                    return <DockerfileBlock isDarkTheme={account.isDarkTheme} updateDockerfiles={updateDockerfiles} dockerfiles={dockerfiles} key={dockerfile.dockerUuid} updateDockerArray={updateDockerArray} updateDeleteDocker={updateDeleteDocker} dockerfile={dockerfile}/>
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className="side-nav-info-header">
                                        Account Settings
                                    </div>
                                    <AccountInput top={"Full Name"} required={true} value={form.name} updateValue={updateName} autoComplete={"name"}/>
                                    <div className="input-field padding auto">
                                        <div className="top-input bottom">
                                            Email Address
                                        </div>
                                        <EmailAddress email={account.primaryEmail} primary={false}/>
                                    </div>
                                    {
                                        pageInfo.map((item) => {
                                            return <AccountInput key={item.top} top={item.top} required={item.required} value={item.value} updateValue={item.updateValue} autoComplete={item.autoComplete}/>
                                        })
                                    }
                                    <SaveChanges left="Cancel" right={{ small : text, large : text }} resetForm={ resetForm } submitForm={submitForm}/>
                                    <div className="logout" onClick={ handleLogout }>
                                        <AccountInstructor /> Log out of All Devices
                                    </div>
                                    <Support />
                                    <div className="pp-and-tac">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="var(--accent-one)" viewBox="0 0 16 16">
                                            <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1"/>
                                        </svg>
                                        <span className="item-of-tac" onClick={(e) => handleClick(e, "privacy-policy")}>Privacy Policy</span> 
                                        <span style={{ color: "var(--almost-black)", textDecoration: "none" }}>and</span> 
                                        <span className="item-of-tac" onClick={(e) => handleClick(e, "terms-and-conditions")}>Terms and Conditions</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }            
            { deleteDocker.delete && deleteDocker.dockerfile ? <DeleteDockerAccount removeFromDockerfile={removeFromDockerfile} dockerfile={deleteDocker.dockerfile} updateDeleteDocker={updateDeleteDocker}/> : <></> }
        </>
    );
}

export default AccountSettings;